import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../../services/account.service';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UploadDataComponent } from './upload-data/upload-data.component';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { MigrateFileComponent } from './migrate-file/migrate-file.component';
import { RevertFileComponent } from './revert-file/revert-file.component';
import { ViewDataComponent } from './view-data/view-data.component';
import { ExportComponent } from './export/export.component';
@Component({
  selector: 'app-data-migration-list',
  templateUrl: './data-migration-list.component.html',
  styleUrls: ['./data-migration-list.component.css']
})
export class DataMigrationListComponent implements OnInit {
  dataSource = new MigrationDataSource(this.accountService);
  tableFilters = '';
  screenHeight;
  screenWidth;
  collapsed;
  dataCount: number;
  small_device_display = false;
  displayedColumns =
    ['id', 'name', 'type', 'pname', 'status', 'action','view'];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  id;
  accountId: any;

  constructor(
    private router: Router, private commonFilter: CommonfilterService,
    private activatedRoute: ActivatedRoute, private route: ActivatedRoute, private commonService: CommonfilterService, private accountService: AccountService,
    private dialog: MatDialog
  ) {
    this.onResize();
  }

  ngOnInit() {
    this.route.parent.params.subscribe(params => {
      this.accountId = params['id'];
    });
    this.dataSource.loadDataList(this.tableFilters, 'false', 0, 100, this.accountId);
    this.getTotalCount(this.tableFilters, this.accountId);
  }
  getTotalCount(filters, accountId) {
    this.accountService.getTotalMigrationDataCount(filters, accountId)
      .subscribe(
        res => {
          this.dataCount = res;
        });
  }
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  showInvoiceDetails(uuid) {
    this.router.navigate(['../../../../subscription', 'print'], { queryParams: { invoiceUuid: uuid }, relativeTo: this.activatedRoute });
  }
  dataUpload() {
    const dialogRef = this.dialog.open(UploadDataComponent, {
      width: '600px',
      data: this.accountId
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      this.loadDataListPage();
    });
  }
  export() {
    const dialogRef = this.dialog.open(ExportComponent, {
      width: '700px',
      data: { 'accountId': this.accountId}
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
    });
  }
  migrateFile(upload) {
    const dialogRef = this.dialog.open(MigrateFileComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'uid' : upload.uid, 'migrationTo' : upload.migrationTo}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadDataListPage();
    });
  }
  revertFile(upload) {
    const dialogRef = this.dialog.open(RevertFileComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'uid' : upload.uid}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadDataListPage();
    });
  }
  viewFile(upload) {
    const dialogRef = this.dialog.open(ViewDataComponent, {
      width: '1000px',
          height: '250px',
      data: { 'accountId': this.accountId, 'uid' : upload.uid}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadDataListPage();
    });
  }
  loadDataListPage() {
    const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
  
    this.dataSource.loadDataList(
  
      this.tableFilters,
      'false',
      count,
      this.paginator.pageSize,this.accountId);
  }
}
export class MigrationDataSource implements DataSource<any> {

  constructor(private accountService: AccountService) {

  }
  public loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  private migrationSubject = new BehaviorSubject<any>([]);

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.migrationSubject.asObservable();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.migrationSubject.complete();
    this.loadingSubject.complete();
  }
  loadDataList(filter,
    sortDirection, tcount, pageSize, id) {
    this.loadingSubject.next(true);

    this.accountService.getDataMigrationList(filter, sortDirection,
      tcount, pageSize, id).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(
        salesReps => {
          this.migrationSubject.next(salesReps);
        }
      );
  }


}
